import { create } from 'zustand';
import { ViewMode } from '@/types/builder';

interface BuilderUIState {
  viewMode: ViewMode;
  selectedElementId: string | null;
  isDragging: boolean;
  zoom: number;
  carouselActiveIndex: { [elementId: string]: number };
}

interface BuilderUIStore extends BuilderUIState {
  setViewMode: (viewMode: ViewMode) => void;
  setSelectedElementId: (elementId: string | null) => void;
  setIsDragging: (isDragging: boolean) => void;
  setZoom: (zoom: number) => void;
  setCarouselActiveIndex: (elementId: string, index: number) => void;
  resetCarouselActiveIndex: () => void;
}

const initialUIState: BuilderUIState = {
  viewMode: 'desktop',
  selectedElementId: null,
  isDragging: false,
  zoom: 1,
  carouselActiveIndex: {},
};

export const useBuilderUIStore = create<BuilderUIStore>()((set) => ({
  ...initialUIState,

  setViewMode: (viewMode) => {
    set({ viewMode });
  },

  setSelectedElementId: (elementId) => {
    set({ selectedElementId: elementId });
  },

  setIsDragging: (isDragging) => {
    set({ isDragging });
  },

  setZoom: (zoom) => {
    set({ zoom });
  },

  setCarouselActiveIndex: (elementId, index) => {
    set((state) => ({
      carouselActiveIndex: {
        ...state.carouselActiveIndex,
        [elementId]: index,
      },
    }));
  },

  resetCarouselActiveIndex: () => {
    set({ carouselActiveIndex: {} });
  },
}));
